import React, { useState } from "react";
import useSiteAge from "../hooks/useSiteAge";

export const Footer = () => {
  const [isOpen, setIsOpen] = useState(false);
  const siteAge = useSiteAge("2024-12-16T10:45:57");

  const handleToggle = () => {
    setIsOpen((prev) => {
      const newState = !prev;

      if (newState) {
        setTimeout(() => {
          window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
        }, 50);
      }

      return newState;
    });
  };

  return (
    <div id="footer">
      <div className="container text-center">
        <p
          className="external link"
          style={{ userSelect: "none", cursor: "pointer" }}
          onClick={handleToggle}
        >
          © 2024 – {new Date().getFullYear()}
        </p>

        <div
          style={{
            maxHeight: isOpen ? "100px" : "0",
            overflow: "hidden",
            transition: "max-height 0.3s ease-out",
          }}
        >
          {isOpen && (
            <p>
              Возраст сайта:{" "}
              {siteAge.map((line, index) => (
                <React.Fragment key={index}>
                  {index > 0 && <br />}
                  {line}
                </React.Fragment>
              ))}
            </p>
          )}
        </div>

        {/* <p>Fullstack by Ivan.Nginx</p> */}
      </div>
    </div>
  );
};
